import React from 'react';
import { omit } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Row = (props) => (
  <div {...omit(props, ['block'])} className={
    classNames('row', props.className, {
      'block': props.block
    })
  }/>
);

Row.propTypes = {
  className: PropTypes.string,
  block: PropTypes.bool
};
